export const appHead = {"meta":[{"name":"description","content":" منصة رفيو توفر للمستخدمين الاطلاع على تقييمات و مراجعات لمنتجات و مطاعم و خدمات بكل شفافية و جودة عالية من تجارب حقيقية مما يساعد المستخدمين في اتخاذ قرارات شراء مدروسة بناءً على آراء موثوقة"},{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1"},{"property":"og:type","content":"website"},{"property":"og:description","content":" منصة رفيو توفر للمستخدمين الاطلاع على تقييمات و مراجعات لمنتجات و مطاعم و خدمات بكل شفافية و جودة عالية من تجارب حقيقية مما يساعد المستخدمين في اتخاذ قرارات شراء مدروسة بناءً على آراء موثوقة"},{"property":"og:url","content":"https://reviewapp.sa"},{"property":"og:site_name","content":"رفيو"},{"property":"robots","content":"index,follow"},{"property":"og:image","content":"/website/assets/img/logo/review-logo.png"},{"name":"twitter:card","content":"summary_large_image"},{"property":"twitter:description","content":" منصة رفيو توفر للمستخدمين الاطلاع على تقييمات و مراجعات لمنتجات و مطاعم و خدمات بكل شفافية و جودة عالية من تجارب حقيقية مما يساعد المستخدمين في اتخاذ قرارات شراء مدروسة بناءً على آراء موثوقة"},{"name":"twitter:url","content":"https://reviewapp.sa"},{"name":"twitter:image","content":"/website/assets/img/logo/review-logo.png"},{"name":"facebook-domain-verification","content":"bpmwvwb1fagbvc4af1dple1it8zdrn"},{"name":"apple-itunes-app","content":"app-id=6742455576"}],"link":[{"rel":"sitemap","type":"application/xml","href":"https://reviewapp.sa/sitemap.xml"},{"rel":"icon","type":"image/x-icon","href":"/website/assets/img/favicon/favicon.ico"}],"style":[],"script":[],"noscript":[]}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true